/* eslint-disable max-lines */
import store from 'store';
import {
  OFFER_INIT_GUID,
  OFFER_INIT_WITH_IDOFFER_IDC,
  OFFER_OPERATION_BY_GUID,
  OFFER_LEGAL_CONDITIONS,
  OFFER_COMPLETED,
  OFFER_COMPLETED_KO,
  PRECONTRACT_BY_CAMPAIGN_ID,
  OFFER_COMPONENTS_BY_PARTNER_ID
} from 'store/actions/offer';
import {
  BBVA_OFFER_INIT_RESPONSE,
  BBVA_CUSTOMER_ME_FULL,
  BBVA_CUSTOMER_GLOBAL_POSITION,
  BBVA_OFFER_INIT_RESPONSE_SUMMARY,
  BBVA_OFFER_INIT_RESPONSE_CONFIRM,
  BBVA_LOGIN
} from 'store/actions/bbva';
import { lsGetOfferGuid, lsSetAuthToken2faBBVA } from 'helpers/store';
import { BBVA_REDIRECT_STATE_SUMMARY } from 'store/enums';

const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Legal = () => import(/* webpackChunkName: "pages/views/legal" */ 'views/Legal');
const ContractStep1Request = () =>
  import(
    /* webpackChunkName: "pages/views/contract-step-1-request" */ 'views/Contract/Step-1/Request'
  );
const ContractStep1Identity = () =>
  import(
    /* webpackChunkName: "pages/views/contract-step-1-identity" */ 'views/Contract/Step-1/Identity'
  );
const ContractStep3 = () =>
  import(/* webpackChunkName: "pages/views/contract-step-3" */ 'views/Contract/Step-3');
const ContractStep3Study = () =>
  import(/* webpackChunkName: "pages/views/contract-step-3-study" */ 'views/Contract/Step-3/Study');
const ContractStep4Ok = () =>
  import(/* webpackChunkName: "pages/views/contract-step-4-ok" */ 'views/Contract/Step-4/Ok');
const ContractStep4Ko = () =>
  import(/* webpackChunkName: "pages/views/contract-step-4-ko" */ 'views/Contract/Step-4/Ko');
const ContractStep3Confirm = () =>
  import(
    /* webpackChunkName: "pages/views/contract-step-3-confirm" */ 'views/Contract/Step-3/Confirm'
  );

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

// Redirect to the 404 page
const redirectTo404Page = (next, path) => next({ name: '404', params: { 0: path } });

// Redirect to name router
const redirectToRuterName = (data, next, toRouterName = true) => {
  if (toRouterName && data && data.routerName !== 'redirect') {
    const routerName = data.routerName;
    next({ name: routerName });
  } else if (toRouterName && data && data.url) {
    window.location.href = data.url;
  } else {
    next();
  }
};

const bbvaOfferInitDispatch = (to, from, next) => {
  store
    .dispatch(`bbva/${BBVA_OFFER_INIT_RESPONSE}`, {
      params: to.params,
      query: to.query
    })
    .then(resp => {
      redirectToRuterName(resp, next);
    })
    .catch(() => {
      redirectToErrorPage(next, BBVA_OFFER_INIT_RESPONSE);
    });
};

const bbvaOfferInitDispatchConfirm = (to, from, next) => {
  store
    .dispatch(`bbva/${BBVA_OFFER_INIT_RESPONSE_CONFIRM}`, {
      params: to.params,
      query: to.query
    })
    .then(resp => {
      redirectToRuterName(resp, next);
    })
    .catch(() => {
      redirectToErrorPage(next, BBVA_OFFER_INIT_RESPONSE_CONFIRM);
    });
};

const redirectToLoginBBVA = (state, params) => {
  store.dispatch(`bbva/${BBVA_LOGIN}`, { idOffer: params.idOffer }).then(({ urlRedirect }) => {
    if (urlRedirect) {
      window.location.href = `${urlRedirect}&state=${state}`;
    }
  });
};

export default [
  {
    path: '/:idOffer(\\d+)/:partnerId(\\d+)/:idc(\\d+)?',
    component: Layout,
    children: [
      {
        path: '/',
        component: ContractStep1Request,
        meta: { titleKey: 'step1Request' },
        name: 'step-1-request',
        beforeEnter(to, from, next) {
          store
            .dispatch(`offer/${OFFER_INIT_WITH_IDOFFER_IDC}`, to.params)
            .then(() => {
              Promise.all([
                store.dispatch(`offer/${OFFER_LEGAL_CONDITIONS}`, '1'),
                store.dispatch(`offer/${PRECONTRACT_BY_CAMPAIGN_ID}`)
              ])
                .then(() => next())
                .catch(() => {
                  redirectToErrorPage(next, OFFER_LEGAL_CONDITIONS);
                });
            })
            .catch(() => {
              redirectToErrorPage(next, OFFER_INIT_WITH_IDOFFER_IDC);
            });
        }
      }
    ]
  },
  {
    path: '/:guid([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
    component: Layout,
    children: [
      {
        path: '/',
        component: ContractStep1Identity,
        meta: { titleKey: 'step1Identity' },
        name: 'step-1-identity',
        beforeEnter(to, from, next) {
          store
            .dispatch(`offer/${OFFER_INIT_GUID}`, to.params)
            .then(resp => {
              if (!resp || (resp && resp === 'identify')) {
                store
                  .dispatch(`offer/${OFFER_LEGAL_CONDITIONS}`, '1')
                  .then(() => redirectToRuterName(resp, next))
                  .catch(() => {
                    redirectToErrorPage(next, OFFER_LEGAL_CONDITIONS);
                  });
              } else {
                redirectToRuterName(resp, next);
              }
            })
            .catch(() => {
              redirectToErrorPage(next, OFFER_INIT_GUID);
            });
        }
      }
    ]
  },
  {
    path: '/bbva-connect-guid',
    name: 'bbva-connect-guid',
    meta: { titleKey: 'redirect' },
    beforeEnter(to) {
      redirectToLoginBBVA(`/${lsGetOfferGuid()}`, to.params);
      // Podemos Redirigir al step-2-guid
      // redirectToRuterName({ routerName: 'step-2-guid' }, next);
    }
  },
  {
    path: '/bbva-connect-summary',
    name: 'bbva-connect-summary',
    meta: { titleKey: 'redirect' },
    beforeEnter(to, from, next) {
      // Redirigir al step-2-summary
      redirectToRuterName({ routerName: 'step-2-summary' }, next);
    }
  },
  {
    path: '/contract',
    component: Layout,
    children: [
      {
        path: '/',
        beforeEnter(to, from, next) {
          redirectTo404Page(next, to.path);
        }
      },
      {
        path: 'identify',
        component: ContractStep1Identity,
        name: 'identify',
        meta: { titleKey: 'step1Identity', step: 1 },
        beforeEnter(to, from, next) {
          if (lsGetOfferGuid()) {
            next();
          } else {
            redirectTo404Page(next, to.path);
          }
        }
      },
      {
        path: 'step-2/:idOffer(\\d+)/:partnerId(\\d+)/:idc(\\d+)?',
        name: 'step-2',
        meta: { titleKey: 'redirect' },
        beforeEnter(to, from, next) {
          store
            .dispatch(`offer/${OFFER_INIT_WITH_IDOFFER_IDC}`, to.params)
            .then(() => {
              bbvaOfferInitDispatchConfirm(to, from, next);
            })
            .catch(() => {
              redirectToErrorPage(next, OFFER_INIT_WITH_IDOFFER_IDC);
            });
        }
      },
      {
        path:
          'step-2/:guid([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
        name: 'step-2-guid',
        meta: { titleKey: 'redirect' },
        beforeEnter(to, from, next) {
          bbvaOfferInitDispatch(to, from, next);
        }
      },
      {
        path: `step-2/${BBVA_REDIRECT_STATE_SUMMARY}`,
        name: 'step-2-summary',
        meta: { titleKey: 'redirect' },
        beforeEnter(to, from, next) {
          store
            .dispatch(`bbva/${BBVA_OFFER_INIT_RESPONSE_SUMMARY}`, {
              query: to.query
            })
            .then(resp => {
              redirectToRuterName(resp, next);
            })
            .catch(() => {
              redirectToErrorPage(next, BBVA_OFFER_INIT_RESPONSE_SUMMARY);
            });
        }
      },
      {
        path: 'step-2',
        name: 'step-2',
        meta: { titleKey: 'step2' },
        beforeEnter(to, from, next) {
          // Example url https://localhost:8080/contract/step-2?code=753b4611-1a90-4a1c-a214-4f2e9cb1aa1b&state=%2F27496971%2F59591
          const { error, state, code } = to.query;
          if (state && (error || code)) {
            next(error ? state : `contract/step-2${state}?code=${code}`);
          } else {
            redirectTo404Page(next, to.path);
          }
        }
      },
      {
        path: 'step-2fa',
        name: 'step-2fa',
        meta: { titleKey: 'step2fa' },
        beforeEnter(to, from, next) {
          // Aquí solo controlar la vuelta del 2FA y llamar o no al mefull en caso de que venga bien o no no hacer nada más porque ya está en lo otro de arriba
          // Example url https://localhost:8080/contract/step-2fa?2FASESSID=67f3d4df-843e-46e8-8742-a322fe598306&status=ok
          const { status } = to.query;
          if (status === 'ok') {
            lsSetAuthToken2faBBVA({
              token2fa: to.query['2FASESSID']
            });
            store
              .dispatch(`bbva/${BBVA_CUSTOMER_ME_FULL}`, { authBtk2fa: true })
              .then(resp => {
                redirectToRuterName(resp, next);
              })
              .catch(() => {
                redirectToErrorPage(next, BBVA_CUSTOMER_ME_FULL);
              });
          } else {
            redirectTo404Page(next, to.path);
          }
        }
      },
      {
        path: 'step-3',
        component: ContractStep3,
        name: 'step-3',
        meta: { titleKey: 'step3', step: 3 },
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`offer/${OFFER_OPERATION_BY_GUID}`),
            store.dispatch(`bbva/${BBVA_CUSTOMER_GLOBAL_POSITION}`)
          ])
            .then(() => {
              store
                .dispatch(`offer/${OFFER_LEGAL_CONDITIONS}`, '6')
                .then(() => next())
                .catch(() => {
                  redirectToErrorPage(next, OFFER_LEGAL_CONDITIONS);
                });
            })
            .catch(() => {
              redirectToErrorPage(next, OFFER_OPERATION_BY_GUID);
            });
        }
      },
      {
        path: 'step-3-confirm',
        component: ContractStep3Confirm,
        name: 'step-3-confirm',
        meta: { titleKey: 'step3Confirm', step: 3 },
        props: { stepName: 'step-3-confirm' }
      },
      {
        path: 'step-3-study',
        component: ContractStep3Study,
        name: 'step-3-study',
        meta: { titleKey: 'step3', step: 0 },
        props: { stepName: 'paso-3-study' },
        beforeEnter(to, from, next) {
          store
            .dispatch(`offer/${OFFER_COMPONENTS_BY_PARTNER_ID}`, 'paso-3-study')
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, OFFER_COMPONENTS_BY_PARTNER_ID);
            });
        }
      }
    ]
  },
  {
    path: '/completed',
    component: Layout,
    children: [
      {
        path: '/',
        beforeEnter(to, from, next) {
          redirectTo404Page(next, to.path);
        }
      },
      {
        path: ':guid([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})?/ok',
        component: ContractStep4Ok,
        name: 'step-4-ok',
        meta: { titleKey: 'step4Ok' },
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`offer/${OFFER_COMPLETED}`, {
              params: to.params,
              query: to.query
            }),
            store.dispatch(
              `offer/${OFFER_OPERATION_BY_GUID}`,
              to.name,
              to.params.guid || lsGetOfferGuid()
            )
          ])
            .then(resp =>
              store.dispatch(`offer/${OFFER_COMPONENTS_BY_PARTNER_ID}`, 'step-4-ok').then(() => {
                redirectToRuterName(
                  resp,
                  next,
                  resp && resp[0] && resp[0].routerName !== 'step-4-ok'
                );
              })
            )
            .catch(() => {
              redirectToErrorPage(next, OFFER_COMPLETED);
            });
        }
      },
      {
        path: 'ko',
        component: ContractStep4Ko,
        name: 'step-4-ko',
        meta: { titleKey: 'step4Ko' },
        beforeEnter(to, from, next) {
          store
            .dispatch(`offer/${OFFER_COMPLETED_KO}`)
            .then(resp => {
              if (resp && resp === '404') {
                redirectTo404Page(next, to.path);
              } else {
                next();
              }
            })
            .catch(() => {
              redirectToErrorPage(next, OFFER_COMPLETED_KO);
            });
        }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    props: { whithoutSubHeader: true },
    children: [
      {
        path: 'legal/:type',
        component: Legal,
        name: 'legal',
        props: { whithoutLinksFooter: true },
        meta: { titleKey: 'legal' }
      },
      {
        path: 'error',
        name: 'error',
        component: Error,
        props: { type: '500_es-ES' },
        meta: { titleKey: 'error' }
      },
      {
        path: '*',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound' }
      }
    ]
  }
];
